const actionTypes = {
  UPDATE_SESSION: 'UPDATE_SESSION',
  UPDATE_PROFILE: 'UPDATE_PROFILE',
  UPDATE_CUSTOMER: 'UPDATE_CUSTOMER',
  UPDATE_IS_PROFILE_SYNCED: 'UPDATE_IS_PROFILE_SYNCED',
  UPDATE_IS_CUSTOMER_SYNCED: 'UPDATE_IS_CUSTOMER_SYNCED',
  HANDLE_ALERT: 'HANDLE_ALERT',
  UPDATE_THEME: 'UPDATE_THEME',
  UPDATE_FONT_SIZE: 'UPDATE_FONT_SIZE',
  UPDATE_TRANSCRIPTION: 'UPDATE_TRANSCRIPTION',
  UPDATE_TRANSLATION: 'UPDATE_TRANSLATION'
};

export default actionTypes;



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js